export default __webpack_public_path__ + "static/media/paper-rule1.41d7ca83.svg";